import { useMsal } from "@azure/msal-react";

const clientTenantId = process.env.REACT_APP_CLIENT_TENANT_ID;

const useLoggedInAccount = () => {
  const { instance, accounts, inProgress } = useMsal();

  const accs = accounts.filter((acc) => acc.tenantId === clientTenantId);
  const loggedInAccount = accs.length > 0 ? accs[0] : undefined;

  return {
    loggedInAccount,
    instance,
    inProgress,
  };
};

export default useLoggedInAccount;
